import { TypeChecker } from '@attain-apps/type-guards'

import type { Color } from './color'
import type { Scale } from './scale'

/**
 * @deprecated try {@link Scale}
 */
export namespace Legacy {
  /* eslint-disable @typescript-eslint/no-shadow */
  export enum PredefinedStyle {
    Primary = 'primary',
    Secondary = 'secondary',
    Success = 'success',
    Info = 'info',
    Warning = 'warning',
    Danger = 'danger',
    Transparent = 'transparent',
    White = 'white',
    Gray = 'gray',
    /* eslint-enable @typescript-eslint/no-shadow */
  }
  const PREDEFINED_STYLES: Set<PredefinedStyle> = new Set<PredefinedStyle>(
    Object.values(PredefinedStyle) as PredefinedStyle[],
  )
  export namespace PredefinedStyle {
    export const isPredefinedStyle =
      TypeChecker.Factory.oneOf(PREDEFINED_STYLES)
  }

  export enum Primary {
    Darkest = '#1D2669',
    Darker = '#283593',
    Dark = '#3F51B5',
    Neutral = '#5C6BC0',
    Light = '#7986CB',
    Lighter = '#C5CAE9',
    Lightest = '#E8EAF6',
  }
  const PRIMARY: Set<Primary> = new Set<Primary>(
    Object.values(Primary) as Primary[],
  )
  export namespace Primary {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    export const ALL: readonly Primary[] = Array.from(PRIMARY)
  }

  export enum Secondary {
    Darkest = '#601B3D',
    Darker = '#8C2247',
    Dark = '#B92D5D',
    Neutral = '#CF3164',
    Light = '#E44C7D',
    Lighter = '#F5BDD1',
    Lightest = '#FAE5EC',
  }

  const SECONDARY: Set<Secondary> = new Set<Secondary>(
    Object.values(Secondary) as Secondary[],
  )
  export namespace Secondary {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    export const ALL: readonly Secondary[] = Array.from(SECONDARY)
  }
  export enum Success {
    Darkest = '#144239',
    Darker = '#1A574E',
    Dark = '#207065',
    Neutral = '#25897D',
    Light = '#3AA69B',
    Lighter = '#B5DFDB',
    Lightest = '#E1F2F1',
  }

  const SUCCESS: Set<Success> = new Set<Success>(
    Object.values(Success) as Success[],
  )
  export namespace Success {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    export const ALL: readonly Success[] = Array.from(SUCCESS)
  }

  export enum Warning {
    Darkest = '#C76812',
    Darker = '#E89D22',
    Dark = '#FBC02D',
    Neutral = '#FFDB35',
    Light = '#FCEC55',
    Lighter = '#FFF9C4',
    Lightest = '#FFFDE7',
  }

  const WARNING: Set<Warning> = new Set<Warning>(
    Object.values(Warning) as Warning[],
  )
  export namespace Warning {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    export const ALL: readonly Warning[] = Array.from(WARNING)
  }

  export enum Danger {
    Darkest = '#752622',
    Darker = '#B03B37',
    Dark = '#CD4643',
    Neutral = '#E96361',
    Light = '#DE7E80',
    Lighter = '#FBD1D7',
    Lightest = '#FDEDF0',
  }

  const DANGER: Set<Danger> = new Set<Danger>(Object.values(Danger) as Danger[])
  export namespace Danger {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    export const ALL: readonly Danger[] = Array.from(DANGER)
  }

  export enum Information {
    Darkest = '#005E76',
    Darker = '#007FA3',
    Dark = '#389BC2',
    Neutral = '#5CAAC0',
    Light = '#79B9CB',
    Lighter = '#C5E1E9',
    Lightest = '#E8F3F6',
  }

  const INFORMATION: Set<Information> = new Set<Information>(
    Object.values(Information) as Information[],
  )
  export namespace Information {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    export const ALL: readonly Information[] = Array.from(INFORMATION)
  }

  export enum Shades {
    Darkest = '#263238',
    Darker = '#37474F',
    Dark = '#455A64',
    Neutral = '#607D8B',
    Light = '#90A4AE',
    Lighter = '#CFD8DC',
    Lightest = '#ECEFF1',
  }

  const SHADES: Set<Shades> = new Set<Shades>(Object.values(Shades) as Shades[])
  export namespace Shades {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    export const ALL: readonly Shades[] = Array.from(SHADES)
  }

  export enum Main {
    /* eslint-disable @typescript-eslint/no-shadow */
    Primary = Legacy.Primary.Dark,
    Secondary = Legacy.Secondary.Dark,
    Success = Legacy.Success.Light,
    Warning = Legacy.Warning.Dark,
    Danger = Legacy.Danger.Dark,
    Information = Legacy.Information.Darker,
    Shades = Legacy.Shades.Dark,
    /* eslint-enable @typescript-eslint/no-shadow */
  }

  const MAIN: Set<Main> = new Set<Main>(Object.values(Main) as Main[])
  export namespace Main {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    export const ALL: readonly Main[] = Array.from(MAIN)
  }

  export enum Status {
    /* eslint-disable @typescript-eslint/no-shadow */
    Success = Main.Success,
    Warning = Main.Warning,
    Danger = Main.Danger,
    Information = Main.Information,
    /* eslint-enable @typescript-eslint/no-shadow */
  }

  const COLORS = new Set([
    ...Primary.ALL,
    ...Secondary.ALL,
    ...Success.ALL,
    ...Warning.ALL,
    ...Danger.ALL,
    ...Information.ALL,
    ...Shades.ALL,
  ])

  export const ALL: readonly Color[] = Array.from(COLORS)
}
